export default __webpack_public_path__ + "static/media/xqdefault.77b731e1.png";